import {prefix_agent} from "./api"

export default {

  async getRewardsSettings() {
    const result = await this.apiClient.get('rewards/settings')
    return result.data
  },
  async updateRewardsSettings(data){
    const result = await this.apiClient.put('rewards/settings', data)
    return result.data
  },
}
